

import PatientDetail from './PatientDetail.js'
export default PatientDetail